var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExitDetention(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#77acf1;}.cls-2{fill:#04009a;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "5. Box Check",
    id: "_5._Box_Check"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M10,1h6a0,0,0,0,1,0,0V6.13a.87.87,0,0,1-.87.87H10.87A.87.87,0,0,1,10,6.13V1A0,0,0,0,1,10,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M11,26H3a3,3,0,0,1-3-3V3A3,3,0,0,1,3,0H23a3,3,0,0,1,3,3v8a1,1,0,0,1-2,0V3a1,1,0,0,0-1-1H3A1,1,0,0,0,2,3V23a1,1,0,0,0,1,1h8a1,1,0,0,1,0,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M7,22H5a1,1,0,0,1,0-2H7a1,1,0,0,1,0,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M23,32a9,9,0,1,1,9-9A9,9,0,0,1,23,32Zm0-16a7,7,0,1,0,7,7A7,7,0,0,0,23,16Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 23,
    cy: 23,
    r: 5
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M23,26a1,1,0,0,1-.71-.29l-2-2a1,1,0,0,1,1.42-1.42L23,23.59l3.29-3.3a1,1,0,0,1,1.42,1.42l-4,4A1,1,0,0,1,23,26Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExitDetention);
export default __webpack_public_path__ + "static/media/exit-detention.fbcd496176237df77dc7d7b5b7d1e320.svg";
export { ForwardRef as ReactComponent };